import { render, staticRenderFns } from "./update-algo-data-details.html?vue&type=template&id=d6c4d546&scoped=true&external"
import script from "./update-algo-data-details.js?vue&type=script&lang=js&external"
export * from "./update-algo-data-details.js?vue&type=script&lang=js&external"
import style0 from "./update-algo-data-details.scss?vue&type=style&index=0&id=d6c4d546&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c4d546",
  null
  
)

export default component.exports